// Frontend version is injected at runtime via a meta tag from Rails.
// This avoids baking the version into the webpack bundle, which would invalidate
// Docker cache on every commit even when frontend code hasn't changed.

let cachedVersion: string | null = null;

export function getBuildkiteFrontendVersion(): string {
  if (cachedVersion === null) {
    const meta = document.querySelector<HTMLMetaElement>("meta[name='buildkite-frontend-version']");
    cachedVersion = meta?.content || "";
  }
  return cachedVersion;
}
